export default __webpack_public_path__ + "static/media/Logo-etermax.e4cf066e.svg";